import { IAsyncSelectOptionWithIcon } from 'interfaces/common'
import { ITag } from 'interfaces/tag'
import { ISearchFilterForm } from 'stores/searchStore'
import { getValidArray } from 'utils/common'

export function getTagOptions(tags: ITag[]): IAsyncSelectOptionWithIcon<number>[] {
  return getValidArray(tags).map(tag => ({
    label: tag?.name,
    value: tag?.id
  }))
}

export function checkValidFilter(searchFilter: ISearchFilterForm): boolean {
  const { groups, tags, sort } = searchFilter
  return sort !== '' || getValidArray(tags)?.length > 0 || getValidArray(groups)?.length > 0
}
